define('views/content/products',['require','views/base/list_page_view','views/components/product/products','collections/products','text!templates/content/products.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var ProductsView = require('views/components/product/products');
    var ProductsCollection = require('collections/products');

    var temp = require("text!templates/content/products.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'product-page',
        titleKey: 'products',

        setCollection: function () {
            this.collection = new ProductsCollection();
        },

        onRender: function() {
            this.ListContainer.show(new ProductsView({
                collection: this.collection
            }));
        }

    });
});
